<template>
  <section class="flex margin-top-s column">
    <!-- filters -->
    <div class="flex-1 flex column w100 middle">
      <div class="flex-1 w100">
        <div class="flex end filters-group-holder between">
          <div style="margin-right: 16px;" class="flex column no-mobile">
            <label>Atualizar</label>
            <div class="flex end w100" style="margin-top:12px">
              <div @click="forceRefreshData()" class="button secondary">
                <i class="fas fa-sync-alt"></i>
              </div>
            </div>
          </div>
          <div style="margin-right: 16px;" class="flex column no-mobile">
            <label>Exportar</label>
            <div class="flex end w100" style="margin-top:12px">
              <div @click="exportData()" class="button secondary">
                <i class="fas fa-download"></i>
              </div>
            </div>
          </div>

          <ltk-date-picker
            label="Filtro de data"
            v-model="filters.data.date"
            :loading="loading"
          ></ltk-date-picker>
        </div>
      </div>
    </div>

    <!-- overview -->
    <div class="flex row w100">
      <div class="item flex-1 w100">
        <box-info
          class=""
          icon="fas fa-users"
          label="Total de Leads"
          tooltip=""
          :value="stats.leads"
          :money="false"
          :currency="filters.data.currency"
        >
        </box-info>
      </div>
      <div class="item flex-1 w100">
      </div>
      <div class="item flex-1 w100">
      </div>
    </div>

    <div class="flex-1 w100 margin-top-s">
      <div class="flex">
        <tabs :data="reportTabs" v-model="currentTab"></tabs>
      </div>
    </div>

    <!-- graph round -->
    <section v-if="currentTab == 'graph'" class="flex w100 column">
      <div class="box graphs flex w100 margin-top-s">
        <div class="box-content flex row middle center w100">
          <div class="flex-1 flex middle column">
            <h4>Top 5 UTM_CAMPAIGN</h4>
            <round-graph
              class="graph"
              :loading="loading"
              :options="graphOptions"
              :chartData="chartUtmCampaign"
            ></round-graph>
          </div>
          <div class="flex-1 flex middle column">
            <h4>Top 5 UTM_MEDIUM</h4>
            <round-graph
              class="graph"
              :loading="loading"
              :options="graphOptions"
              :chartData="chartUtmMedium"
            ></round-graph>
          </div>

          
        </div>
      </div>
      <div class="box graphs flex w100 margin-top-s">
        <div class="box-content flex row middle center w100">
          <div class="flex-1 flex middle column">
            <h4>Top 5 UTM_SOURCE</h4>
            <round-graph
              class="graph"
              :loading="loading"
              :options="graphOptions"
              :chartData="chartUtmSource"
            ></round-graph>
          </div>
          <div class="flex-1 flex middle column">
            <h4>Top 5 UTM_CONTENT</h4>
            <round-graph
              class="graph"
              :loading="loading"
              :options="graphOptions"
              :chartData="chartUtmContent"
            ></round-graph>
          </div>
        </div>
      </div>

      <div class="box graphs flex w100 margin-top-s">
        <div class="box-content flex row middle center w100">
          <div class="flex-1 flex middle column">
            <h4>Top 5 UTM_TERM</h4>
            <round-graph
              class="graph"
              :loading="loading"
              :options="graphOptions"
              :chartData="chartUtmTerm"
            ></round-graph>
          </div>
        </div>
      </div>

      <div class="box graphs flex w100 margin-top-s">
        <div class="box-content flex row middle center w100">
          <div class="flex-1 flex middle column">
            <h4>Top 5 SRC</h4>
            <round-graph
              class="graph"
              :loading="loading"
              :options="graphOptions"
              :chartData="chartSrc"
            ></round-graph>
          </div>
          <div class="flex-1 flex middle column">
            <h4>Top 5 SCK</h4>
            <round-graph
              class="graph"
              :loading="loading"
              :options="graphOptions"
              :chartData="chartSck"
            ></round-graph>
          </div>
        </div>
      </div>
      
    </section>
    <section v-if="currentTab == 'table'" class="flex w100 column">
      <!-- summary utms -->
      <div class="flex w100">
        <div class="box flex-1 w100 margin-top-s">
          <div class="flex box-title middle">
            <div class="flex-1">
              <h4>
                Melhores Resultados por UTM
              </h4>
            </div>
          </div>
          <div class="box-content">
            <!-- utm_campaign -->
            <ul>
              <li class="header">
                <div class="flex middle row">
                  <div class="flex-1">
                    <div class="flex middle row">
                      <div class="flex-1 name">
                        UTM_CAMPAIGN
                      </div>
                      <div class="flex-1">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            <p>Leads</p>
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <p>Receita Bruta</p>
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <p>Receita Líquida</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li v-for="(track, index) in UTMS.utm_campaign" :key="index">
                <div class="flex middle row">
                  <div class="flex-3">
                    <div class="flex middle row">
                      <div class="flex-1 name margin-top-s">
                        <p>
                          {{ track.name | protect }}
                        </p>
                      </div>
                      <div class="flex-1 margin-top-s">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            {{ track.stats.leads | number }}
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <small
                              >{{ track.stats.receita_bruta | money }} ({{
                                track.stats.leads | number
                              }})</small
                            >
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <small
                              >{{ track.stats.approved_sales_sum | money }} ({{
                                track.stats.sales | number
                              }})</small
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <!-- utm_medium -->
            <ul>
              <li class="header">
                <div class="flex middle row">
                  <div class="flex-1">
                    <div class="flex middle row">
                      <div class="flex-1 name">
                        UTM_MEDIUM
                      </div>
                      <div class="flex-1">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            <p>Leads</p>
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <p>Receita Bruta</p>
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <p>Receita Líquida</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li v-for="(track, index) in UTMS.utm_medium" :key="index">
                <div class="flex middle row">
                  <div class="flex-3">
                    <div class="flex middle row">
                      <div class="flex-1 name margin-top-s">
                        <p>
                          {{ track.name | protect }}
                        </p>
                      </div>
                      <div class="flex-1 margin-top-s">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            {{ track.stats.leads | number }}
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <small
                              >{{ track.stats.receita_bruta | money }} ({{
                                track.stats.leads | number
                              }})</small
                            >
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <small
                              >{{ track.stats.approved_sales_sum | money }} ({{
                                track.stats.sales | number
                              }})</small
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <!-- utm_source -->
            <ul>
              <li class="header">
                <div class="flex middle row">
                  <div class="flex-1">
                    <div class="flex middle row">
                      <div class="flex-1 name">
                        UTM_SOURCE
                      </div>
                      <div class="flex-1">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            <p>Leads</p>
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <p>Receita Bruta</p>
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <p>Receita Líquida</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li v-for="(track, index) in UTMS.utm_source" :key="index">
                <div class="flex middle row">
                  <div class="flex-3">
                    <div class="flex middle row">
                      <div class="flex-1 name margin-top-s">
                        <p>
                          {{ track.name | protect }}
                        </p>
                      </div>
                      <div class="flex-1 margin-top-s">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            {{ track.stats.leads | number }}
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <small
                              >{{ track.stats.receita_bruta | money }} ({{
                                track.stats.leads | number
                              }})</small
                            >
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <small
                              >{{ track.stats.approved_sales_sum | money }} ({{
                                track.stats.sales | number
                              }})</small
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <!-- utm_content -->
            <ul>
              <li class="header">
                <div class="flex middle row">
                  <div class="flex-1">
                    <div class="flex middle row">
                      <div class="flex-1 name">
                        UTM_CONTENT
                      </div>
                      <div class="flex-1">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            <p>Leads</p>
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <p>Receita Bruta</p>
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <p>Receita Líquida</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li v-for="(track, index) in UTMS.utm_content" :key="index">
                <div class="flex middle row">
                  <div class="flex-3">
                    <div class="flex middle row">
                      <div class="flex-1 name margin-top-s">
                        <p>
                          {{ track.name | protect }}
                        </p>
                      </div>
                      <div class="flex-1 margin-top-s">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            {{ track.stats.leads | number }}
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <small
                              >{{ track.stats.receita_bruta | money }} ({{
                                track.stats.leads | number
                              }})</small
                            >
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <small
                              >{{ track.stats.approved_sales_sum | money }} ({{
                                track.stats.sales | number
                              }})</small
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <!-- utm_term -->
            <ul>
              <li class="header">
                <div class="flex middle row">
                  <div class="flex-1">
                    <div class="flex middle row">
                      <div class="flex-1 name">
                        UTM_TERM
                      </div>
                      <div class="flex-1">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            <p>Leads</p>
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <p>Receita Bruta</p>
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <p>Receita Líquida</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li v-for="(track, index) in UTMS.utm_term" :key="index">
                <div class="flex middle row">
                  <div class="flex-3">
                    <div class="flex middle row">
                      <div class="flex-1 name margin-top-s">
                        <p>
                          {{ track.name | protect }}
                        </p>
                      </div>
                      <div class="flex-1 margin-top-s">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            {{ track.stats.leads | number }}
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <small
                              >{{ track.stats.receita_bruta | money }} ({{
                                track.stats.leads | number
                              }})</small
                            >
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <small
                              >{{ track.stats.approved_sales_sum | money }} ({{
                                track.stats.sales | number
                              }})</small
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>

            <!-- SRC -->
            <ul>
              <li class="header">
                <div class="flex middle row">
                  <div class="flex-1">
                    <div class="flex middle row">
                      <div class="flex-1 name">
                        SRC
                      </div>
                      <div class="flex-1">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            <p>Leads</p>
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <p>Receita Bruta</p>
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <p>Receita Líquida</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li v-for="(track, index) in UTMS.src" :key="index">
                <div class="flex middle row">
                  <div class="flex-3">
                    <div class="flex middle row">
                      <div class="flex-1 name margin-top-s">
                        <p>
                          {{ track.name | protect }}
                        </p>
                      </div>
                      <div class="flex-1 margin-top-s">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            {{ track.stats.leads | number }}
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <small
                              >{{ track.stats.receita_bruta | money }} ({{
                                track.stats.leads | number
                              }})</small
                            >
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <small
                              >{{ track.stats.approved_sales_sum | money }} ({{
                                track.stats.sales | number
                              }})</small
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>

            <!-- sck -->
            <ul>
              <li class="header">
                <div class="flex middle row">
                  <div class="flex-1">
                    <div class="flex middle row">
                      <div class="flex-1 name">
                        SCK
                      </div>
                      <div class="flex-1">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            <p>Leads</p>
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <p>Receita Bruta</p>
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <p>Receita Líquida</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li v-for="(track, index) in UTMS.sck" :key="index">
                <div class="flex middle row">
                  <div class="flex-3">
                    <div class="flex middle row">
                      <div class="flex-1 name margin-top-s">
                        <p>
                          {{ track.name | protect }}
                        </p>
                      </div>
                      <div class="flex-1 margin-top-s">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            {{ track.stats.leads | number }}
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <small
                              >{{ track.stats.receita_bruta | money }} ({{
                                track.stats.leads | number
                              }})</small
                            >
                          </div>
                          <div v-if="false" class="flex-1 txt-center">
                            <small
                              >{{ track.stats.approved_sales_sum | money }} ({{
                                track.stats.sales | number
                              }})</small
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>

            <div v-if="isEmpty" class="center-text">
              <div class="margin-top-l">
                <p>
                  Não encontramos nenhuma origem de venda. Assim que você tiver
                  a primeira venda a origem vai aparecer nessa lista de forma
                  automática!
                </p>
              </div>
            </div>

            <div v-if="loading">
              <content-loading>
                <fake-line height="30"></fake-line>
                <fake-line height="30"></fake-line>
                <fake-line height="30"></fake-line>
                <fake-line height="30"></fake-line>
              </content-loading>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- group by sale -->
    <div class="box flex-1 w100 margin-top-l no-mobile">
      <div class="flex box-title middle">
        <div class="flex-1">
          <h4>
            Explorador de UTMS
          </h4>
        </div>
        <div class="flex end filters-group-holder between">
          <div class="filter-item">
            <label>Buscar</label>
            <div class="flex w100">
              <input class="input" type="text" v-model="filters.data.search" />
            </div>
          </div>
          <div class="filter-item">
            <label>Agrupar por</label>
            <select class="input" v-model="filters.data.group_by">
              <option
                v-for="(c, index) in filters.list.group_by"
                :key="index"
                :value="c.value"
                :selected="c.value === filters.data.group_by"
              >
                {{ c.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="box-content">
        <ul>
          <li class="header">
            <div class="flex middle row">
              <div class="flex-1">
                <div class="flex middle row">
                  <div class="flex-1 name">
                    {{ filters.data.group_by }}
                  </div>
                  <div class="flex-1">
                    <div class="flex details between">
                      <div class="flex-1 txt-center">
                        <p>Leads</p>
                      </div>
                      <div v-if="false" class="flex-1 txt-center">
                        <p>Receita Bruta</p>
                      </div>
                      <div v-if="false" class="flex-1 txt-center">
                        <p>Receita Líquida</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li v-for="(track, index) in trackings" :key="index">
            <div class="flex middle row">
              <div class="flex-3">
                <div class="flex middle row">
                  <div class="flex-1 name margin-top-s">
                    <p>
                      {{ track.name | protect }}
                    </p>
                  </div>
                  <div class="flex-1 margin-top-s">
                    <div class="flex details between">
                      <div class="flex-1 txt-center">
                        {{ track.stats.leads | number }}
                      </div>
                      <div v-if="false" class="flex-1 txt-center">
                        <small
                          >{{ track.stats.receita_bruta | money }} ({{
                            track.stats.leads | number
                          }})</small
                        >
                      </div>
                      <div v-if="false" class="flex-1 txt-center">
                        <small
                          >{{ track.stats.approved_sales_sum | money }} ({{
                            track.stats.sales | number
                          }})</small
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="false" class="action">
                <div class="flex end">
                  <router-link
                    :to="{
                      name: 'ProductDetail',
                      params: { product_id: product.id },
                    }"
                  >
                    <div class="button primary">Relatório</div>
                  </router-link>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <div v-if="isEmpty" class="center-text">
          <div class="margin-top-l">
            <p>
              Não encontramos nenhuma origem de venda. Assim que você tiver a
              primeira venda a origem vai aparecer nessa lista de forma
              automática!
            </p>
          </div>
        </div>

        <div v-if="loading">
          <content-loading>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
          </content-loading>
        </div>

        <!-- pagination -->
        <div class="flex-1 flex row w100 middle margin-top-l">
          <div class="flex w100 center filters-groupo-holder">
            <div class="flex between middle">
              <paginate
                :containerClass="'pagination'"
                :page-count="totalPages"
                v-model="page"
                :page-range="5"
                :click-handler="clickCallback"
                :prev-text="'Anterior'"
                :next-text="'Próxima'"
              ></paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");

import { getTrackingsLead } from "@/services/tracking.js";
import ltkDatePicker from "@/components/datepicker/LtkDatePicker";

// import barChart from "@/components/charts/barChart";
import boxInfo from "@/components/boxInfo/BoxInfo";
import RoundGraph from "@/components/charts/RoundGraph";
import Tabs from "@/components/tabs/Tabs";

export default {
  name: "source-lead",
  components: {
    ltkDatePicker,
    boxInfo,
    RoundGraph,
    Tabs,
    // barChart
  },
  data() {
    return {
      loading: false,
      currentTab: "graph",
      reportTabs: [
        {
          name: "graph",
          title: "Gráfico",
        },
        {
          name: "table",
          title: "Tabela",
        },
      ],
      filters: {
        data: {
          date: [
            moment()
              .add(-0, "d")
              .startOf("day")
              .toDate(),
            moment()
              .startOf("day")
              .toDate(),
          ],
          group_by: "utm_campaign",
          search: "",
        },
        list: {
          group_by: [
            {
              value: "utm_campaign",
              label: "utm_campaign",
            },
            {
              value: "utm_source",
              label: "utm_source",
            },
            {
              value: "utm_medium",
              label: "utm_medium",
            },
            {
              value: "utm_content",
              label: "utm_content",
            },
            {
              value: "utm_term",
              label: "utm_term",
            },
            {
              value: "sck",
              label: "sck",
            },
            {
              value: "src",
              label: "src",
            },
          ],
        },
      },
      UTMS: {
        utm_campaign: [],
        utm_medium: [],
        utm_source: [],
        utm_content: [],
        utm_term: [],
        src: [],
        sck: [],
      },
      trackings: [],
      totalTracking: 0,
      stats: {
        sales: 0,
        receita_bruta: 0,
        receita_liquida: 0,
      },
      offset: 10,
      page: 1,
      refreshTime: 60,
      refreshInterval: null,
      graphOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          labels: {
            fontColor: "black",
          },
        },
        drawTicks: true,
        cutout: 70,
      },
    };
  },
  mounted() {
    this.getTrackings();
    this.refreshInterval = setInterval(
      this.getTrackings,
      this.refreshTime * 1000
    );
  },
  destroyed() {
    clearInterval(this.refreshInterval);
  },
  computed: {
    chartUtmCampaign() {
      var auxNotEmpty = this.UTMS.utm_campaign
        .filter((e) => e.name && !e.name.includes("Sem UTM"))
        .splice(0, 5);

      var maxE = auxNotEmpty.reduce((acum, v) => acum + v.stats.leads, 0);
      var auxData = auxNotEmpty.map((e) => (e.stats.leads / maxE) * 100)

      return {
        labels: auxNotEmpty.map((e, i) => `(${this.fn(auxData[i])}%) ${e.name.substring(0, 30)}`),
        datasets: [
          {
            label: "Vendas",
            fill: false,
            data: auxData,
            borderWidth: 1,
          },
        ],
      };
    },
    chartUtmMedium() {
      var auxNotEmpty = this.UTMS.utm_medium.filter(
        (e) => e.name && !e.name.includes("Sem UTM")).splice(0, 5);

      var maxE = auxNotEmpty.reduce((acum, v) => acum + v.stats.leads, 0);
        var auxData = auxNotEmpty.map((e) => (e.stats.leads / maxE) * 100)

      return {
        labels: auxNotEmpty.map((e, i) => `(${this.fn(auxData[i])}%) ${e.name.substring(0, 30)}`),
        datasets: [
          {
            label: "Vendas",
            fill: false,
            data: auxData,
            borderWidth: 1,
          },
        ],
      };
    },
    chartUtmSource() {
      var auxNotEmpty = this.UTMS.utm_source.filter(
        (e) => e.name && !e.name.includes("Sem UTM")).splice(0, 5);

      var maxE = auxNotEmpty.reduce((acum, v) => acum + v.stats.leads, 0);
      var auxData = auxNotEmpty.map((e) => (e.stats.leads / maxE) * 100)
      return {
        labels: auxNotEmpty.map((e, i) => `(${this.fn(auxData[i])}%) ${e.name.substring(0, 30)}`),
        datasets: [
          {
            label: "Vendas",
            fill: false,
            data: auxData,
            borderWidth: 1,
          },
        ],
      };
    },
    chartUtmContent() {
      var auxNotEmpty = this.UTMS.utm_content.filter(
        (e) => e.name && !e.name.includes("Sem UTM")).splice(0, 5);

      var maxE = auxNotEmpty.reduce((acum, v) => acum + v.stats.leads, 0);
      var auxData = auxNotEmpty.map((e) => (e.stats.leads / maxE) * 100)
      return {
        labels: auxNotEmpty.map((e, i) => `(${this.fn(auxData[i])}%) ${e.name.substring(0, 30)}`),
        datasets: [
          {
            label: "Vendas",
            fill: false,
            data: auxData,
            borderWidth: 1,
          },
        ],
      };
    },
    chartUtmTerm() {
      var auxNotEmpty = this.UTMS.utm_term.filter(
        (e) => e.name && !e.name.includes("Sem UTM")).splice(0, 5);

      var maxE = auxNotEmpty.reduce((acum, v) => acum + v.stats.leads, 0);
      var auxData = auxNotEmpty.map((e) => (e.stats.leads / maxE) * 100)
      return {
        labels: auxNotEmpty.map((e, i) => `(${this.fn(auxData[i])}%) ${e.name.substring(0, 30)}`),
        datasets: [
          {
            label: "Vendas",
            fill: false,
            data: auxData,
            borderWidth: 1,
          },
        ],
      };
    },
    chartSrc() {
      var auxNotEmpty = this.UTMS.src.filter(
        (e) => e.name && !e.name.includes("Sem UTM")).splice(0, 5);

      var maxE = auxNotEmpty.reduce((acum, v) => acum + v.stats.leads, 0);
      var auxData = auxNotEmpty.map((e) => (e.stats.leads / maxE) * 100)
      return {
        labels: auxNotEmpty.map((e, i) => `(${this.fn(auxData[i])}%) ${e.name.substring(0, 30)}`),
        datasets: [
          {
            label: "Vendas",
            fill: false,
            data: auxData,
            borderWidth: 1,
          },
        ],
      };
    },
    chartSck() {
      var auxNotEmpty = this.UTMS.sck.filter(
        (e) => e.name && !e.name.includes("Sem UTM")).splice(0, 5);

      var maxE = auxNotEmpty.reduce((acum, v) => acum + v.stats.leads, 0);
      var auxData = auxNotEmpty.map((e) => (e.stats.leads / maxE) * 100)
      return {
        labels: auxNotEmpty.map((e, i) => `(${this.fn(auxData[i])}%) ${e.name.substring(0, 30)}`),
        datasets: [
          {
            label: "Vendas",
            fill: false,
            data: auxData,
            borderWidth: 1,
          },
        ],
      };
    },
    isEmpty() {
      // return !this.loading && this.Trackings && this.Trackings.length === 0;
      return this.totalTracking === 0 && !this.loading;
    },
    totalPages() {
      let valueMode = this.totalTracking % this.offset;
      let value = this.totalTracking / this.offset;

      let pages = 1;

      if (valueMode == 0) {
        pages = value;
      } else {
        pages = parseInt(value) + 1;
      }

      return pages;
    },
  },
  watch: {
    "filters.data": {
      deep: true,
      handler() {
        this.trackings = [];
        this.getTrackings();
      },
    },
    page: {
      handler() {
        this.trackings = [];
        this.getTrackings();
      },
    },
  },
  methods: {
    fn(n) {
      if (!n) return n
      return n.toFixed(2)
    },
    forceRefreshData() {
      this.getTrackings();
    },
    getTrackings() {
      this.loading = true;

      const date = this.filters.data.date;
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
        group_by: this.filters.data.group_by,
        search: this.filters.data.search,
        page: this.page,
        offset: this.offset,
      };
      getTrackingsLead(params)
        .then((result) => {
          this.trackings = result.trackings.map((p) => {
            return {
              name: p.name,
              group_by: p.group_by,
              stats: {
                leads: p.stats.leads,
              },
            };
          });

          // utms
          this.UTMS = result.utms;

          this.totalTracking = result.total;

          this.stats = result.stats;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar tracking",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    exportData() {
      let dataRaw = "CAMPANHA,TOTAL,TOTAL_PAGO,SUM_TOTAL,SUM_PAGO";
      let dataRows = [dataRaw];

      this.trackings.forEach((row) => {
        let auxLine = `${row.name},${row.stats.leads},${row.stats.sales},${row.stats.receita_bruta},${row.stats.approved_sales_sum}`;
        dataRows.push(auxLine);
      });

      dataRows = dataRows.join("\n");

      var fileURL = window.URL.createObjectURL(new Blob([dataRows]));
      var fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", "exportacao-tabela-tracking.csv");
      document.body.appendChild(fileLink);
      fileLink.click();

      this.$toast.success({
        title: "Sucesso",
        message: "Exportação gerada com sucesso",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
li {
  list-style-type: none;
  padding-bottom: 8px;
  padding-top: 8px;
  border-bottom: 1px solid #e6e4e4;
  padding-left: 8px;
}

.details {
  > div {
    margin-right: 34px;
    p {
      line-height: 20px;
    }
    small {
      font-weight: 800;
    }
  }
}

.name {
  small {
    font-weight: 800;
  }
}

.profit {
  .green {
    color: green;
  }
  .red {
    color: red;
  }
}

.pagination {
  margin: 0px !important;
}
.box-primary {
  background: var(--primary);
  color: #fff;
}

.header {
  // margin-bottom: 18px;
  font-size: 14px;
  font-weight: 800;
  background: var(--primary);
  color: #fff;
  padding: 8px 8px;
  border-radius: 4px;
}

grid-flex .box + .box,
.flex .box + .box {
  margin-left: 0px;
}

.graphs {
  .graph {
    max-width: 100%;
    max-height: 300px;
  }
}

@media screen and (max-width: 1024px) {
  .details {
    flex-direction: column;

    > div {
      margin-right: 8px;
      margin-top: 8px;
      display: flex;
      align-items: center;

      p::after {
        content: ":";
      }
      small {
        margin-left: 8px;
      }
    }
  }
  .action {
    margin-top: 16px;
  }
}
</style>
